import * as React from 'react';

/** TODO: выпилить это. Заменить на useLocation */
// eslint-disable-next-line import-x/no-extraneous-dependencies
import { Location } from 'history';

import { Comment } from './comment';
import { CommentForm } from './comment_form';
import { IComment, ICommentState } from '../../types/posts';
import { IUser } from '../../types/user';
import { IScrollComment } from '../../types/scroll_comment';

import s from './comments.css';

interface IProps {
  location: Location;
  canComment: boolean;
  canSubscribeComments: boolean;
  user: IUser;
  likesShown: boolean;
  author?: IUser;
  restrictComments: boolean;
  count: number;
  commentsState: ICommentState;
  comments?: IComment[];
  onCommentEdit(id: number, comment: string, email: string): void;
  onCommentDelete(id: number, email: string): void;
  onCommentHide(id: number, email: string): void;
  onCommentSubmit(
    comment: string,
    userId: number,
    fullName: string,
    email: string,
    parentID: number | null,
    subs: boolean,
  ): void;
  showSubscribeDialog(): void;
  showUnsubscribeDialog(): void;
  subscribed?: boolean;
  scrollCommentState: IScrollComment;
  scrollCommentDisabled(): void;
  cardType: string;
}

export const Comments: React.FC<IProps> = ({
  location,
  canComment,
  canSubscribeComments,
  user,
  likesShown,
  author,
  restrictComments,
  commentsState,
  comments,
  onCommentEdit,
  onCommentDelete,
  onCommentHide,
  onCommentSubmit,
  showSubscribeDialog,
  showUnsubscribeDialog,
  subscribed,
  scrollCommentState,
  scrollCommentDisabled,
  cardType,
}) => {
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const [addingComment, setAddingComment] = React.useState(false);
  const [, setEditingComment] = React.useState(false);

  const prevLoadedRef = React.useRef(commentsState.loaded);
  const prevScrollFormRef = React.useRef(scrollCommentState.isScrollForm);

  const scrollToComments = React.useCallback(() => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    if (scrollCommentDisabled) {
      scrollCommentDisabled();
    }
  }, [scrollCommentDisabled]);

  React.useEffect(() => {
    if (scrollCommentState?.isScrollComments) {
      scrollToComments();
    }
  });

  React.useEffect(() => {
    const wasLoaded = prevLoadedRef.current;
    prevLoadedRef.current = commentsState.loaded;

    const wasScrollForm = prevScrollFormRef.current;
    prevScrollFormRef.current = scrollCommentState.isScrollForm;

    if (!commentsState.error && commentsState.loaded && commentsState.loaded !== wasLoaded) {
      if (!scrollCommentState.isScrollForm) {
        setAddingComment(false);
        setEditingComment(false);
      }
    }

    if (scrollCommentState.isScrollForm && scrollCommentState.isScrollForm !== wasScrollForm) {
      setAddingComment(true);
      setEditingComment(false);
    }
  }, [commentsState.error, commentsState.loaded, scrollCommentState.isScrollForm]);

  const handleOpenCommentForm = () => {
    if (user.userId === -1) {
      window.waitForLoginPopup();

      return;
    }

    setAddingComment(true);
    setEditingComment(false);
  };

  const getHeadlineTitle = () => {
    switch (cardType.toLowerCase()) {
      case 'articles':
      case 'news':
      case 'blog':
        return 'Комментарии';
      case 'question':
        return 'Советы';
      default:
        return 'Комментарии';
    }
  };

  const getCommentsCount = () => {
    let count = 0;

    if (!comments) {
      return count;
    }

    for (let i = 0; i < comments.length; i++) {
      count++;
      for (let j = 0; j < comments[i].comments.length; j++) {
        count++;
      }
    }

    return count;
  };

  const renderSubscribe = () => {
    const isQuestion = cardType === 'Question';

    if (subscribed) {
      return (
        <span role="button" onClick={() => showUnsubscribeDialog()} className={s['comments__subscribe']}>
          Отписаться от {isQuestion ? 'советов' : 'комментариев'}
        </span>
      );
    }

    return (
      <span role="button" onClick={() => showSubscribeDialog()} className={s['comments__subscribe']}>
        Подписаться на {isQuestion ? 'советы' : 'комментарии'}
      </span>
    );
  };

  return (
    <div className={s['comments']} ref={wrapperRef}>
      <div className={s['comments__headline']}>
        <span className={s['comments___headline_title']}>{getHeadlineTitle()} </span>
        <span className={s['comments__headline_num']} itemProp="commentCount">
          {getCommentsCount()}
        </span>
        {canSubscribeComments && <span className={s['subscribe-wrap']}>{renderSubscribe()}</span>}
      </div>
      {comments && comments.length > 0 && (
        <div className={s['comments__list']}>
          {comments.map((comment: IComment) => (
            <Comment
              location={location}
              canComment={canComment}
              user={user}
              likesShown={likesShown}
              author={author}
              restrictComments={restrictComments}
              comment={comment}
              onCommentSubmit={(
                commentText: string,
                userId: number,
                fullName: string,
                email: string,
                parentID: number | null,
                subs: boolean,
              ) => onCommentSubmit(commentText, userId, fullName, email, parentID, subs)}
              onCommentEdit={onCommentEdit}
              onCommentDelete={onCommentDelete}
              onCommentHide={onCommentHide}
              commentsState={commentsState}
              key={`comment-${comment.id}`}
              cardType={cardType}
            />
          ))}
        </div>
      )}
      {canComment && (
        <CommentForm
          onClose={() => {
            setAddingComment(false);
            setEditingComment(false);
          }}
          onOpen={handleOpenCommentForm}
          onCommentSubmit={(
            comment: string,
            userId: number,
            fullName: string,
            email: string,
            parentID: number | null,
            subs: boolean,
          ) => onCommentSubmit(comment, userId, fullName, email, parentID, subs)}
          commentsState={commentsState}
          onCommentEdit={onCommentEdit}
          replyTo=""
          isOpened={addingComment}
          parentID={null}
          user={user}
          scrollCommentState={scrollCommentState}
          scrollCommentDisabled={scrollCommentDisabled}
          cardType={cardType}
        />
      )}
    </div>
  );
};
